/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Gets Response from api:
 * /v1/ua/aces_case_programs_product_deliveries/{caseId}
 *
 * @param {string} caseId.
 * @param {any} callback function to call once this function has finished
 */
const getAcesCaseProgramsProductDeliveriesByCaseIdUtil = (caseId, callback) => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/aces_case_programs_product_deliveries/${caseId}`,
    models.Response
  );
};

export { getAcesCaseProgramsProductDeliveriesByCaseIdUtil };
